/**
 * CacheTimestamp - Displays when data was cached
 * Shows "Data cached at: Dec 6, 2025, 9:51 AM PT" or "Cache info not available" if not cached
 *
 * TODO: Formalize this as a polymorphic component that handles all cache variants:
 * - Cached data with timestamp (current)
 * - Live/uncached data (SSE, WebSocket)
 * - Stale data with refresh action
 * - Loading/refreshing state
 * Consolidate the helper functions (formatCacheTimestamp, force-refresh patterns)
 * so all routes share a single consistent cache status UI.
 */

interface CacheTimestampProps {
  /** ISO string of when data was cached, or null if not cached */
  cachedAt: string | null;
  /** Optional className for additional styling */
  className?: string;
}

/**
 * Format a cache timestamp for display
 * Returns formatted date string like "Dec 6, 2025, 9:51 AM PT"
 */
function formatCacheTimestamp(isoString: string): string {
  return new Date(isoString).toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles',
    dateStyle: 'medium',
    timeStyle: 'short',
  }) + ' PT';
}

export function CacheTimestamp({ cachedAt, className = '' }: CacheTimestampProps) {
  const baseClasses = 'font-mono text-sm text-muted-foreground';

  if (!cachedAt) {
    return (
      <p className={`${baseClasses} ${className}`}>
        Cache info not available
      </p>
    );
  }

  return (
    <p className={`${baseClasses} ${className}`}>
      Data cached at: {formatCacheTimestamp(cachedAt)}
    </p>
  );
}
